/* ==========================================================================
   AVICOO — CORE
   Phase 0 · Namespace, module registry, Theme Editor lifecycle
   --------------------------------------------------------------------------
   Exposes exactly one global: window.AVICOO
   Contains no component logic and touches no storefront DOM.

   Breakpoint values mirror the --avc-bp-* tokens in avicoo-tokens.css.
   Change both together.
   ========================================================================== */

(function () {
  'use strict';

  if (window.AVICOO) return;

  var BREAKPOINTS = {
    xs: 480,
    sm: 750,
    md: 990,
    lg: 1200,
    xl: 1440,
    xxl: 1600,
  };

  var registry = {};
  var booted = false;

  /**
   * Register a module. The initialiser receives a scope element and is
   * responsible for finding its own nodes within it.
   */
  function register(name, init, destroy) {
    if (typeof name !== 'string' || typeof init !== 'function') return;
    registry[name] = { init: init, destroy: destroy || null };
    if (booted) safeInit(name, document);
  }

  function safeInit(name, scope) {
    try {
      registry[name].init(scope || document);
    } catch (error) {
      if (window.Shopify && window.Shopify.designMode) {
        console.error('[AVICOO] init failed: ' + name, error);
      }
    }
  }

  function safeDestroy(name, scope) {
    var entry = registry[name];
    if (!entry || !entry.destroy) return;
    try {
      entry.destroy(scope || document);
    } catch (error) {
      if (window.Shopify && window.Shopify.designMode) {
        console.error('[AVICOO] destroy failed: ' + name, error);
      }
    }
  }

  /** Initialise every registered module within a scope. */
  function init(scope) {
    Object.keys(registry).forEach(function (name) {
      safeInit(name, scope);
    });
  }

  /** Tear down every registered module within a scope. */
  function destroy(scope) {
    Object.keys(registry).forEach(function (name) {
      safeDestroy(name, scope);
    });
  }

  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  /** True when the viewport is at or above a named breakpoint. */
  function atLeast(name) {
    var value = BREAKPOINTS[name];
    if (!value || !window.matchMedia) return false;
    return window.matchMedia('(min-width: ' + value + 'px)').matches;
  }

  function boot() {
    if (booted) return;
    booted = true;
    document.documentElement.classList.add('avc-ready');
    init(document);
  }

  window.AVICOO = {
    version: '0.1.0',
    breakpoints: BREAKPOINTS,
    modules: registry,
    register: register,
    init: init,
    destroy: destroy,
    prefersReducedMotion: prefersReducedMotion,
    atLeast: atLeast,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  /* Theme Editor lifecycle. Without these, every module built in later
     phases would break the moment a merchant edits a section. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
  });
})();